import { Card } from '@equinor/eds-core-react';
import styled from 'styled-components';
import { spacings } from '../../../tokens/spacings';
import { theme } from '../../../tokens/theme';

export const Container = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: ${spacings.MEDIUM};
  padding: ${spacings.LARGE};
  border: 1px solid ${theme.light.ui.background.medium};
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.08);
`;
